"use client";

import {
  EnvelopeSimple,
  Phone,
  WhatsappLogo,
  YoutubeLogo,
} from "@phosphor-icons/react";
import { LinkedinLogo } from "@phosphor-icons/react/dist/ssr";
import Image from "next/image";
import FooterMobile from "./MobileFooter";
import Link from "next/link";

const getCoursePath = (course) => {
  const id = course?.id || course?._id || course?.course_id || course?.slug;
  return id ? `/courses/${id}` : null;
};

const socialLinks = {
    whatsappUrl:
      "https://api.whatsapp.com/send/?phone=919220361603&text=Hey%20I%20am%20interested%20in%20one%20of%20your%20course",

      youtubeUrl: "https://www.youtube.com/@SOFAR-Analytics",
  };

const Footer = ({ courses }) => {
  const footerData = [
    {
      title: "Courses",
      items: (courses || [])
        .map((course) => ({
          label: course?.title || "Untitled",
          href: getCoursePath(course),
        }))
        .filter((item) => item.href),
    },
    {
      title: "Upcoming Batches",
      items: (courses || [])
        .map((course) => ({
          label: course?.title || "Untitled",
          href: getCoursePath(course),
        }))
        .filter((item) => item.href),
    },
    {
      title: "Articles",
      items: [
        { label: "Blogs", href: "/blog" },
        { label: "Study Material", href: null },
      ],
    },
    {
      title: "About Us",
      items: [
        { label: "Reviews", href: null },
        { label: "Our Trainers", href: null },
      ],
    },
  ];

  return (
    <>
      <footer className="hidden md:block w-full bg-[#222222] py-[96px] px-[80px]">
        <div className="flex flex-col gap-[72px]">
          <div className="flex flex-col gap-[16px]">
            <div className="flex justify-between">
              <div>
                <Image
                  src={"/sofar_logo.svg"}
                  alt="Logo"
                  width={255}
                  height={106}
                />
              </div>
              <div className="flex flex-col gap-[24px]">
                <div className="flex gap-[8px] items-center text-white">
                  <span>
                    <EnvelopeSimple size={32} />
                  </span>
                  <p className="text-[16px] font-[400]">
                    sofarindia.helpdesk@gmail.com
                  </p>
                </div>
                <div className="flex gap-[8px] items-center text-white">
                  <span>
                    <Phone size={32} />
                  </span>
                  <p className="text-[16px] font-[400]">+91 92203 61603</p>
                </div>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <div className="w-[255px] flex justify-between items-center text-white pl-[20px]">
                <LinkedinLogo size={32} />
                <a href={socialLinks.whatsappUrl} target="_blank" rel="noopener noreferrer">
                  <WhatsappLogo size={32} />
                </a>
                <a href={socialLinks.youtubeUrl} target="_blank" rel="noopener noreferrer">
                <YoutubeLogo size={32} />
                </a>
              </div>
            </div>
          </div>

          <div className="text-white pl-[20px]">
            <div className="flex flex-col gap-[40px]">
              <div className="grid grid-cols-4 gap-[40px]">
                {footerData.map((section, index) => (
                  <div key={index}>
                    <h3 className="font-[600] mb-[16px] underline underline-offset-4 text-[16px]">
                      {section.title}
                    </h3>
                    <ul className="space-y-[16px]">
                      {section.items.map((item, idx) => (
                        <li key={idx} className="cursor-pointer">
                          {item?.href ? (
                            <Link href={item.href} className="hover:text-primary transition-colors">
                              {item.label}
                            </Link>
                          ) : (
                            <span className="text-gray-300">{item?.label}</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <div className="pt-[40px] border-t border-[#E4E4E4]">
                <div className="flex flex-col sm:flex-row justify-between gap-4 text-[12px]">
                  <div className="flex gap-[16px] flex-wrap">
                    <Link href="/privacy-policy" className="hover:text-blue-400 transition-colors">
                      Privacy Policy
                    </Link>
                    <p>|</p>
                    <p>© 2025 All Rights Reserved</p>
                  </div>
                  <div className="flex gap-[16px] flex-wrap">
                    <Link href="/terms-and-conditions" className="hover:text-blue-400 transition-colors">
                      Terms and Conditions
                    </Link>
                    <p>|</p>
                    <Link href="/terms-and-conditions" className="hover:text-blue-400 transition-colors">
                      Refund and Cancellation Policy
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <FooterMobile courses={courses} />
    </>
  );
};

export default Footer;
